module.exports = __webpack_public_path__ + "assets/JTUSjIg1_i6t8kCHKm459WZhyzbi-22c946.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2
// module id = 846
// module chunks = 2